import { cls } from '~/utils';

interface GClickableProps {
  children: React.ReactNode;
  fullWidth?: boolean;
  cursor?: 'pointer' | 'default' | 'not-allowed';
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const GClickable = ({
  children,
  fullWidth = false,
  cursor = 'pointer',
  onClick,
  onMouseEnter,
  onMouseLeave,
}: GClickableProps) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={cls({
        'w-full': fullWidth,
        'cursor-pointer': cursor === 'pointer',
        'cursor-default': cursor === 'default',
        'cursor-not-allowed': cursor === 'not-allowed',
      })}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};
